import { render, staticRenderFns } from "./AxMealManualNewDialog.vue?vue&type=template&id=07b9d650&scoped=true"
import script from "./AxMealManualNewDialog.vue?vue&type=script&lang=ts"
export * from "./AxMealManualNewDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxMealManualNewDialog.vue?vue&type=style&index=0&id=07b9d650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9d650",
  null
  
)

export default component.exports